import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../auth/authContext";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { createUser } from "../../API/ApiUsers";

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { ReactReduxContext } from "react-redux";
import { getEstados, getMunicipios } from "../../API/ApiEstadosMunicipios";
import { DateTime } from "luxon";
import { createNewOrder } from "../../API/ApiOrdenesServicio";
import InputAdornment from "@mui/material/InputAdornment";
import { FactCheckIcon } from "@mui/icons-material/FactCheck";
import {
  agregarServicioAOrdenDeServicio,
  getServiciosOrdenesServicio,
} from "../../API/ApiServiciosOrdenesServicio";
import { nuevoPagoOrdenServicio } from "../../API/ApiPagosOrdenes";
import { agregarJardinAPanteon } from "../../API/ApiJardines";
import { AddPanteon } from "../../API/ApiPanteones";
import {
  AgregarUniplexByIdJardin,
  AsignarContratoAUniplexByIdEspacio,
} from "../../API/ApiUniplex";
import { LoadingComponent } from "../LoadingComponent/LoadingComponent";
import {
  AgregarEspaciosACapillaByIdCapilla,
  AsignarContratoAEspacioCapillaByIdEspacio,
  AsignarPersonaAEspacioCapillaByIdEspacio,
} from "../../API/ApiCapillas";

import Autocomplete from "@mui/material/Autocomplete";
import { searchContracts } from "../../API/ApiContratos";
import { AsignarContratoADuplexByIdEspacio } from "../../API/ApiDuplex";
import { AsignarFechaAContratoIdEspacio } from "../../API/ApiEspacios";

export const AsignarFechaDeinicioDePagoaEspacioComponent = (props) => {
  const { user, dispatch } = React.useContext(AuthContext);
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [finalData, setFinalData] = React.useState([]);

  const [fechaAsignacion, setFechaAsignacion] = React.useState("2023-04-26");

  console.log(props);

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      props.setCrudAction({ action: null, data: null });
    }
  };

  React.useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  return (
    <>
      <div className="crudDivComponent col-md-3 px-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 my-2 mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6>Asigna fecha de ocupación del espacio </h6>
                  <small className="text-muted">
                    La fecha de asignación alterará el cálculo del mantenimiento{" "}
                    <br />
                    <strong>Pulsa Enter para guardar</strong>
                  </small>
                </div>
                <div>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() =>
                      props.setCrudAction({ action: null, data: null })
                    }
                  >
                    <CloseIcon fontSize="inherit" />{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {isDisabled == true ? (
                <>
                  <Alert className="mb-3" severity="info">
                    Procesando información...
                  </Alert>
                </>
              ) : null}
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="container-fluid">
              <div className="row row-cols-1">
                <div className="col">
                  <TextField
                    id="fechaDeAsignacions"
                    label="fechaDeAsignacion"
                    variant="outlined"
                    value={fechaAsignacion}
                    onChange={(e) => {
                      console.log(e.target.value);

                      setFechaAsignacion(e.target.value);
                    }}
                    type={"date"}
                    fullWidth={true}
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <div className="col">
                  <hr />
                  <div
                    className="btn btn-sm btn-danger w-100"
                    onClick={() => {
                      setIsDisabled(true);
                      AsignarFechaAContratoIdEspacio(user, {
                        idcontrato: props.crudAction.data.idcontrato,
                        idubicacion: props.idEspacio,
                        fechaAsignacion: fechaAsignacion,
                      }).then((resultado) => {
                        props.setCrudAction({ action: null, data: null });

                        if (resultado.status === 200) {
                          toast.success(
                            "Fecha de espacio actualizada exitosamente"
                          );
                        }

                        setIsDisabled(false);
                      });
                    }}
                  >
                    Actualizar Fecha
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
